// import back1 from '../assets/icon/s_filters/back1.svg'
// import back2 from '../assets/icon/s_filters/back2.svg'
// import back3 from '../assets/icon/s_filters/back3.svg'
// import back4 from '../assets/icon/s_filters/back4.svg'

// import lapel1 from '../assets/icon/s_filters/lapel1.svg'
// import lapel2 from '../assets/icon/s_filters/lapel2.svg'
// import lapel3 from '../assets/icon/s_filters/lapel3.svg'
// import lapel4 from '../assets/icon/s_filters/lapel4.svg'

// import style1 from '../assets/icon/s_filters/style1.svg'
// import style2 from '../assets/icon/s_filters/style2.svg'
// import style3 from '../assets/icon/s_filters/style3.svg'

// import pocket1 from '../assets/icon/s_filters/pocket1.svg'
// import pocket2 from '../assets/icon/s_filters/pocket2.svg'
// import pocket3 from '../assets/icon/s_filters/pocket3.svg'

// import fabricImg from '../assets/selectF.jpg'

// import coat from '../assets/samples/coat/red_coat.png'
// import Shirt from '../assets/samples/shirt/grey_shirt.png'
// import pant from '../assets/samples/pant/red_pant.png'
// import vest from '../assets/samples/jacket/green_jacket.png'

// import green_coat_single from '../assets/samples/coat/g1_coat_single.png'
// import red_coat_single from '../assets/samples/coat/red_coat_single.png'
// import red_coat_back from '../assets/samples/coat/red_coat_back.png'
// import green_coat_back from '../assets/samples/coat/green_coat_back.png'

// import red_jacket from '../assets/samples/jacket/red_jacket_single.png'
// import green_jacket from '../assets/samples/jacket/green_jacket_single.png'

// import grey_shirt from '../assets/samples/shirt/grey_shirt_single.png'
// import pink_shirt from '../assets/samples/shirt/pink_shirt_single.png'

// import black_pant from '../assets/samples/pant/black_pant_single.png'
// import green_pant from '../assets/samples/pant/green_pant_single.png'

// import gcoat from '../assets/samples/coat/green_coat.png'
// import pShirt from '../assets/samples/shirt/orange_shirt.png'
// import gpant from '../assets/samples/pant/green_pant.png'
// import vest1 from '../assets/samples/jacket/red_jacket.png'

import sChart_in from "../assets/measurments/SC_IN.png";
import sChart_cm from "../assets/measurments/SC_CM.png";


// import {ReactComponent as one_button } from '../assets/SVG/SINGLE BUTTON-01.svg'
import one_button from "../assets/SVG/SINGLE BUTTON-01.svg";
import two_button from "../assets/SVG/double button-01.svg";
import three_button from "../assets/SVG/three button-01.svg";
import four_button from "../assets/SVG/four button-01.svg";
import six_button from "../assets/SVG/six button-01.svg";

import one_button_tux from "../assets/SVG/SVG_COAT/SINGLE BUTTON TUX.svg";
import two_button_tux from "../assets/SVG/SVG_COAT/double button TUX.svg";
import three_button_tux from "../assets/SVG/SVG_COAT/three button TUX.svg";
import four_button_tux from "../assets/SVG/SVG_COAT/four button TUX.svg";
import six_button_tux from "../assets/SVG/SVG_COAT/SIX button TUX.svg";

import j_round from "../assets/SVG/ROUND-01.svg";
import j_semiround from "../assets/SVG/semi round-01.svg";
import j_straight from "../assets/SVG/STRAIGHT-01.svg";
import j_open from '../assets/SVG/OPEN JODHPURI-01.svg'

import Notch from "../assets/SVG/Notch.svg";
import peak from "../assets/SVG/PEAK.svg";
import saul from '../assets/SVG/SVG_COAT/SHAWL LAPLE-01.svg'

import flap from "../assets/SVG/FLAP.svg";
import patch from "../assets/SVG/PATCH.svg";
import wallet from "../assets/SVG/SVG_COAT/WALLET-01.svg"

import upper_pocket_patch from '../assets/SVG/SVG_COAT/PATCH UPPER-01.svg'

import no_stitch from '../assets/SVG/NO TOP STITCH-01.svg'
import stitch from '../assets/SVG/TOP STITCH-01.svg'

import non_vent from "../assets/SVG/NON VENT.svg";
import s_vent from "../assets/SVG/SINGLE VENT.svg";
import side_vent from "../assets/SVG/SIDE VENT.svg";

import non_plates from "../assets/SVG/NON PLATES.svg";
import s_plates from "../assets/SVG/SINGLE PLATE.svg";
import d_plates from "../assets/SVG/DOUBLE PLATES.svg";

import back_pocket from "../assets/SVG/SINGLE POCKET.svg";
import d_pocket from "../assets/SVG/DOUBLE POCKET.svg";

import s_brested from "../assets/SVG/SINGLE BRESTED.svg";
import d_brested from "../assets/SVG/DOUBLE BRESTED.svg";

import semi_spread from "../assets/SVG/SEMI SPREAD.svg";
import spread from "../assets/SVG/SPREAD.svg";

import semi_spread_n from "../assets/SVG/SPREAD_n.svg";

import button_down from "../assets/SVG/BUTTON DOWN.svg";

import round_collar from '../assets/SVG/SVG_SHIRT/round collar-01.svg'

import mand from "../assets/SVG/MANDARIN.svg";

import square from "../assets/SVG/SQUARE.svg";
import ROUND from "../assets/SVG/ROUND.svg";
import NOTCH from "../assets/SVG/NOTCH 1.svg";

import square2 from "../assets/SVG/2SQUARE.svg";
import ROUND2 from "../assets/SVG/2ROUND.svg";
import NOTCH2 from "../assets/SVG/2NOTCH.svg";

import CUFFLINKS from "../assets/SVG/CUFFLINKS.svg";

import shirt_pocket_no from "../assets/SVG/NO POCKET.svg";
import shirt_pocket_1 from "../assets/SVG/POCKET.svg";

import shirt_side_cut from '../assets/SVG/SVG_SHIRT/SIDE CUT.svg'
import shirt_apple_cut from '../assets/SVG/SVG_SHIRT/APPLE CUT.svg'
import shirt_straight_cut from '../assets/SVG/SVG_SHIRT/STRAIGHT.svg'

import shirt_full_sleeve from '../assets/SVG/SVG_SHIRT/FULL SLEEVE.svg'
import shirt_half_sleeve from '../assets/SVG/SVG_SHIRT/HALF SLEEVE.svg'

import P1 from "../assets/suits/product-1.jpg";
import P2 from "../assets/suits/uniform.webp";
import P3 from "../assets/suits/pant_shirt.jpg";

///// Kurta SVGs

import kurta_1POCKET from '../assets/SVG/SVG_KURTA/1 POCKET-01.svg'
import kurta_2FLAP from '../assets/SVG/SVG_KURTA/2 FLAP-01.svg'
import kurta_2POCKET from '../assets/SVG/SVG_KURTA/2 POCKET-01.svg'
import kurta_BOTTOCUTROUND from '../assets/SVG/SVG_KURTA/BOTTO CUT ROUND-01.svg'
import kurta_BOTTOMCUTSQURE from '../assets/SVG/SVG_KURTA/BOTTOM CUT SQURE-01.svg'
import kurta_BUTTONDOWNCOLLAR from '../assets/SVG/SVG_KURTA/BUTTON DOWN COLLAR-01.svg'
import kurta_BUTTONHIDE from '../assets/SVG/SVG_KURTA/BUTTON HIDE-01.svg'
import kurta_BUTTONSHOW from '../assets/SVG/SVG_KURTA/BUTTON SHOW-01.svg'
import kurta_BUTTON from '../assets/SVG/SVG_KURTA/BUTTON-01.svg'
import kurta_CHINACOLLAR from '../assets/SVG/SVG_KURTA/CHINA COLLAR-01.svg'
import kurta_CUFFSLEEVE from '../assets/SVG/SVG_KURTA/CUFF SLEEVE-01.svg'
import kurta_MANDARINCOLLAR from '../assets/SVG/SVG_KURTA/MANDARIN COLLAR-01.svg'
import kurta_MOREBUTTON from '../assets/SVG/SVG_KURTA/MORE BUTTON-01.svg'
import kurta_NOFLAP from '../assets/SVG/SVG_KURTA/NO FLAP-01.svg'
import kurta_NOPOCKET from '../assets/SVG/SVG_KURTA/NO POCKET-01.svg'
import kurta_NOShoulderEpaulette from '../assets/SVG/SVG_KURTA/NO Shoulder Epaulette-01.svg'
import kurta_NONCUFFSLEEVE from '../assets/SVG/SVG_KURTA/NON CUFF SLEEVE-01.svg'
import kurta_NOTCHFLAP from '../assets/SVG/SVG_KURTA/NOTCH FLAP-01.svg'
import kurta_NOTCHPLACKET from '../assets/SVG/SVG_KURTA/NOTCH PLACKET-01.svg'
import kurta_NOTCHPOCKET from '../assets/SVG/SVG_KURTA/NOTCH POCKET-01.svg'
import kurta_ROUNDCOLLAR from '../assets/SVG/SVG_KURTA/ROUND COLLAR-01.svg'
import kurta_ROUNDFLAP from '../assets/SVG/SVG_KURTA/ROUND FLAP-01.svg'
import kurta_ROUNDNECK from '../assets/SVG/SVG_KURTA/ROUND NECK-01.svg'
import kurta_ROUNDPOCKET from '../assets/SVG/SVG_KURTA/ROUND POCKET-01.svg'
import kurta_SEMISPREAD from '../assets/SVG/SVG_KURTA/SEMI SPREAD-01.svg'
import kurta_ShoulderEpaulette from '../assets/SVG/SVG_KURTA/Shoulder Epaulette-01.svg'
import kurta_SPREADCOLLAR from '../assets/SVG/SVG_KURTA/SPREAD COLLAR-01.svg'
import kurta_SQUREFLAP from '../assets/SVG/SVG_KURTA/SQURE FLAP-01.svg'
import kurta_SQUREPLACKET from '../assets/SVG/SVG_KURTA/SQURE PLACKET-01.svg'
import kurta_SQUREPOCKET from '../assets/SVG/SVG_KURTA/SQURE POCKET-01.svg'
import kurta_STANDERDCOLLAR from '../assets/SVG/SVG_KURTA/STANDERD COLLAR-01.svg'
import kurta_LENLONG from '../assets/SVG/SVG_KURTA/len_long.svg'
import kurta_LENSHORT from '../assets/SVG/SVG_KURTA/len_short.svg'

/// pajama SVGs 
import pajama_CHURIDAR from '../assets/SVG/SVG_PAJAMA/CHURIDAR-01-01.svg'
import pajama_DHOTI from '../assets/SVG/SVG_PAJAMA/DHOTI-01.svg'
import pajama_PAJAMA from '../assets/SVG/SVG_PAJAMA/PAJAMA-01.svg'
import pajama_PANTPAJAMA from '../assets/SVG/SVG_PAJAMA/PANT-01.svg'
import pajama_SALWAR from '../assets/SVG/SVG_PAJAMA/SALWAR-01.svg'
import pajama_PATIALA from '../assets/SVG/SVG_PAJAMA/PATIALA-01.svg'
import pajama_ALIGARHI from '../assets/SVG/SVG_PAJAMA/ALIGARHI-01.svg'
import pajama_BELLBOTTOM from '../assets/SVG/SVG_PAJAMA/BELLBOTTOM-01.svg'

import pajama_elastic from '../assets/SVG/SVG_PAJAMA/elastic-01.svg'
import pajama_rope from '../assets/SVG/SVG_PAJAMA/rope-01.svg'

/// Sadri SVGs
import sadri_BUTTON from '../assets/SVG/SVG_SADRI/BUTTON-01.svg'
import sadri_EMBROIDERY from '../assets/SVG/SVG_SADRI/EMBROIDERY-01.svg'
import sadri_HANDEMBOIDERY from '../assets/SVG/SVG_SADRI/HAND EMBOIDERY-01.svg'
import sadri_MOREBUTTON from '../assets/SVG/SVG_SADRI/MORE BUTTON-01.svg'
import sadri_NOVPOCKET from '../assets/SVG/SVG_SADRI/NO V POCKET-01.svg'
import sadri_OFFICER from '../assets/SVG/SVG_SADRI/Officer-01.svg'
import sadri_ROYALWRAP from '../assets/SVG/SVG_SADRI/Royal Wrap-01.svg'
import sadri_AVANTEDGE from '../assets/SVG/SVG_SADRI/Avant Edge-01.svg'
import sadri_RANGER from '../assets/SVG/SVG_SADRI/Ranger-01.svg'
import sadri_ELITEMINIMAL from '../assets/SVG/SVG_SADRI/Elite Minimal-01.svg'
import sadri_METROUTILITY from '../assets/SVG/SVG_SADRI/Metro Utility-01.svg'
import sadri_SIGNATURECURVE from '../assets/SVG/SVG_SADRI/Signature Curve-01.svg'
import sadri_ESSENTIALNEHRU from '../assets/SVG/SVG_SADRI/Essential Nehru-01.svg'
import sadri_COMMAND from '../assets/SVG/SVG_SADRI/Command-01.svg'
import sadri_MODERNROYAL from '../assets/SVG/SVG_SADRI/Modern Royal-01.svg'
import sadri_ROYALASYM from '../assets/SVG/SVG_SADRI/Royal Asym-01.svg'
import sadri_IMPERIALSEAMLESS from '../assets/SVG/SVG_SADRI/Imperial Seamless-01.svg'
import sadri_HERITAGE from '../assets/SVG/SVG_SADRI/Heritage-01.svg'
import sadri_CLASSICLAP from '../assets/SVG/SVG_SADRI/Classic Lapel-01.svg'
import sadri_URBANSAFARI from '../assets/SVG/SVG_SADRI/Urban Safari-01.svg'
import sadri_VPOCKET from '../assets/SVG/SVG_SADRI/V  POCKET-01.svg'

// pant SVGs
import pant_CROSSPOCKET from '../assets/SVG/SVG_PANT/CROSS POCKET.svg'
import pant_CUTBELT from '../assets/SVG/SVG_PANT/CUT BELT.svg'
import pant_DOUBLEBONEX1 from '../assets/SVG/SVG_PANT/DOUBLE BONE X 1.svg'
import pant_DOUBLEBONEX2 from '../assets/SVG/SVG_PANT/DOUBLE BONE X 2.svg'
import pant_FLAPX1 from '../assets/SVG/SVG_PANT/FLAP X 1.svg'
import pant_FLAPX2 from '../assets/SVG/SVG_PANT/FLAP X 2.svg'
import pant_GURKHA from '../assets/SVG/SVG_PANT/GURKHA.svg'
import pant_HOOK from '../assets/SVG/SVG_PANT/HOOK.svg'
import pant_LONGBELT from '../assets/SVG/SVG_PANT/LONG BELT.svg'
import pant_NONPOCKET from '../assets/SVG/SVG_PANT/NON POCKET.svg'
import pant_ROUNDPOCKET from '../assets/SVG/SVG_PANT/ROUND POCKET.svg'
import pant_SINGLEBONEX1 from '../assets/SVG/SVG_PANT/SINGLE BONE X 1.svg'
import pant_SINGLEBONEX2 from '../assets/SVG/SVG_PANT/SINGLE BONE X 2.svg'

// default Body
import hands from '../assets/Body/OLD/half sleeve.webp'
import wrist from '../assets/Body/OLD/full sleeve.webp'
import formal_body from '../assets/Body/OLD/body.webp'

import wrist1 from '../assets/Body/DARK/hand for full sleeve.webp'
import hands1 from '../assets/Body/DARK/hand for half sleeve.webp'
import formal_body1 from '../assets/Body/DARK/body.webp'

import wrist2 from '../assets/Body/MAIN/hand for full sleeve.webp'
import hands2 from '../assets/Body/MAIN/hand for half sleeve.webp'
import formal_body2 from '../assets/Body/MAIN/BODY.webp'

import new_body from '../assets/Body/new_suit_body.webp'
import pant_body_new from '../assets/Body/body_for_pant.webp'
import kurta_body from '../assets/Body/kurta_body.webp'
import pajama_body from '../assets/Body/pajama_body.webp'

// Kurta Skintone Imports
import k_face1 from '../assets/Body/kurta_body/face_1.webp'
import k_face2 from '../assets/Body/kurta_body/face_2.webp'
import k_face3 from '../assets/Body/kurta_body/face_3.webp'
import k_face4 from '../assets/Body/kurta_body/face_4.webp'
import k_face5 from '../assets/Body/kurta_body/face_5.webp'
import k_face6 from '../assets/Body/kurta_body/face_6.webp'
import k_face7 from '../assets/Body/kurta_body/face_7.jpg'

import k_body1 from '../assets/Body/kurta_body/kurta_body_1.webp'
import k_body2 from '../assets/Body/kurta_body/kurta_body_2.webp'
import k_body3 from '../assets/Body/kurta_body/kurta_body_3.webp'
import k_body4 from '../assets/Body/kurta_body/kurta_body_4.webp'
import k_body5 from '../assets/Body/kurta_body/kurta_body_5.webp'
import k_body6 from '../assets/Body/kurta_body/kurta_body_6.webp'
import k_body7 from '../assets/Body/kurta_body/kurta_body_7.webp'

import k_hand_c1 from '../assets/Body/kurta_body/hand_for_cuff-sleeve_1.webp'
import k_hand_c2 from '../assets/Body/kurta_body/hand_for_cuff-sleeve_2.webp'
import k_hand_c3 from '../assets/Body/kurta_body/hand_for_cuff-sleeve_3.webp'
import k_hand_c4 from '../assets/Body/kurta_body/hand_for_cuff-sleeve_4.webp'
import k_hand_c5 from '../assets/Body/kurta_body/hand_for_cuff-sleeve_5.webp'
import k_hand_c6 from '../assets/Body/kurta_body/hand_for_cuff-sleeve_6.webp'
import k_hand_c7 from '../assets/Body/kurta_body/hand_for_cuff-sleeve_7.webp'

import k_hand_n1 from '../assets/Body/kurta_body/hand_for_noncuff-sleeve_1.webp'
import k_hand_n2 from '../assets/Body/kurta_body/hand_for_noncuff-sleeve_2.webp'
import k_hand_n3 from '../assets/Body/kurta_body/hand_for_noncuff-sleeve_3.webp'
import k_hand_n4 from '../assets/Body/kurta_body/hand_for_noncuff-sleeve_4.webp'
import k_hand_n5 from '../assets/Body/kurta_body/hand_for_noncuff-sleeve_5.webp'
import k_hand_n6 from '../assets/Body/kurta_body/hand_for_noncuff-sleeve_6.webp'
import k_hand_n7 from '../assets/Body/kurta_body/hand_for_noncuff-sleeve_7.webp'

export const sizeChart = {
  u: [36, 38, 40, 42, 44, 46, 48, 50, 52],
  l: [30, 32, 34, 36, 38, 40, 42, 44, 46],
  img: [sChart_cm, sChart_in],

};
export const fabrics = [
  { fabric: "Blue Wool", brand: "Raymond", price: "1199" },
  { fabric: "Black Wool", brand: "Raymond1", price: "1200" },
  { fabric: "Green Wool", brand: "Raymond2", price: "1199" },
  { fabric: "Red Wool", brand: "Raymond3", price: "1199" },
  { fabric: "Silk", brand: "Raymond4", price: "1199" },
  { fabric: "Cotton", brand: "Raymond5", price: "1199" },
  { fabric: "Synthetic", brand: "Raymond6", price: "1199" },
  { fabric: "Nylon", brand: "Raymond7", price: "1199" },
  { fabric: "Party", brand: "Raymond8", price: "1199" },
  { fabric: "Sample", brand: "Raymond9", price: "1199" },
];

export const Types = {
  suit: {
    Coat: 0, Shirt: 4, Pant: 1, Vest: 2,
    measurement: 2
  },
  pant: {
    Pant: 0,
    measurement: 1
  },
  shirt: {
    Shirt: 0,
    measurement: 0
  },
  formal: {
    Shirt: 1, Pant: 0,
    measurement: 2
  },
  blazer: {
    Coat: -2,
    measurement: 0
  },
  kurta: {
    Kurta: 1,
    Coat: 0,
    Pajama: 2,
    Sadri: 0,
    measurement: 2
  },
  sadri:{
    Sadri: 0,
    measurement: 0
  },
  only_kurta: {
    Kurta: 1,
    Pajama: 2,
    measurement: 0
  },
  pajama: {
    Pajama: 0,
    measurement: 1
  }
};

export const PajamaColors = {
  white: { id: "pajama_white", name: "White Pajama", brand: "Maviinci", src: "https://firebasestorage.googleapis.com/v0/b/bluepearl-e9750.firebasestorage.app/o/Kurta%2FPajama%2FPAJAMA-1726940263526", price: 0, pos: 2 },
  cream: { id: "pajama_cream", name: "Cream Pajama", brand: "Maviinci", src: "https://firebasestorage.googleapis.com/v0/b/bluepearl-e9750.firebasestorage.app/o/Kurta%2FPajama%2FPAJAMA-1726940263526", price: 0, pos: 2 },
  black: { id: "pajama_black", name: "Black Pajama", brand: "Maviinci", src: "https://firebasestorage.googleapis.com/v0/b/bluepearl-e9750.firebasestorage.app/o/Kurta%2FPajama%2FPAJAMA-1726940263526", price: 0, pos: 2 },
  gray: { id: "pajama_gray", name: "Gray Pajama", brand: "Maviinci", src: "https://firebasestorage.googleapis.com/v0/b/bluepearl-e9750.firebasestorage.app/o/Kurta%2FPajama%2FPAJAMA-1726940263526", price: 0, pos: 2 },
  brown: { id: "pajama_brown", name: "Brown Pajama", brand: "Maviinci", src: "https://firebasestorage.googleapis.com/v0/b/bluepearl-e9750.firebasestorage.app/o/Kurta%2FPajama%2FPAJAMA-1726940263526", price: 0, pos: 2 }
};

// export const dummyImg  = {
//     "suits":{
//         "Shirt":Shirt,
//         "Pant":gpant,
//     }
// }

// export const Fabrics_all = {
//     "Coat":[
//         {"fabric": "Blue Wool", "brand":"Raymond", "price":"1000"
//             ,"src":coat, "fabricIMG":fabricImg, "single" : [red_coat_single, red_coat_back]
//         },
//         {"fabric": "Green Wool", "brand":"Ray1", "price":"1200"
//             ,"src":gcoat, "fabricIMG":fabricImg, "single" : [green_coat_single, green_coat_back]
//         },
//         {"fabric": "Green Wool", "brand":"Raymond2", "price":"1199"
//             ,"src":gcoat, "fabricIMG":fabricImg, "single" : [green_coat_single, green_coat_back]
//         },
//         {"fabric": "Red Wool", "brand":"Raymond3", "price":"1199"
//             ,"src":gcoat, "fabricIMG":fabricImg, "single" : [green_coat_single, green_coat_back]
//         },
//         {"fabric": "Silk", "brand":"Raymond4", "price":"1199"
//             ,"src":gcoat, "fabricIMG":fabricImg, "single" : [green_coat_single, green_coat_back]
//         },
//         {"fabric": "Cotton", "brand":"Raymond5", "price":"1199"
//             ,"src":gcoat, "fabricIMG":fabricImg, "single" : [green_coat_single, green_coat_back]
//         },
//         {"fabric": "Synthetic", "brand":"Raymond6", "price":"1199"
//             ,"src":gcoat, "fabricIMG":fabricImg, "single" : [green_coat_single, green_coat_back]
//         }
//     ],
//     "Pant":[
//         {"fabric": "Blue Wool", "brand":"Raymond", "price":"1000"
//             ,"src":pant, "fabricIMG":fabricImg, "single" : [black_pant]
//         },
//         {"fabric": "Green Wool", "brand":"Raymond1", "price":"1200"
//             ,"src":gpant, "fabricIMG":fabricImg, "single" : [green_pant]
//         },
//         {"fabric": "Green Wool", "brand":"Raymond2", "price":"1199"
//             ,"src":gpant, "fabricIMG":fabricImg, "single" : [green_pant]
//         },
//         {"fabric": "Red Wool", "brand":"Raymond3", "price":"1199"
//             ,"src":gpant, "fabricIMG":fabricImg, "single" : [green_pant]
//         },
//         {"fabric": "Silk", "brand":"Raymond4", "price":"1199"
//             ,"src":gpant, "fabricIMG":fabricImg, "single" : [green_pant]
//         },
//         {"fabric": "Cotton", "brand":"Raymond5", "price":"1199"
//             ,"src":gpant, "fabricIMG":fabricImg, "single" : [green_pant]
//         },
//         {"fabric": "Synthetic", "brand":"Raymond6", "price":"1199"
//             ,"src":gpant, "fabricIMG":fabricImg, "single" : [green_pant]
//         }
//     ],
//     "Shirt":[
//         {"fabric": "Blue Wool", "brand":"Raymond", "price":"1000"
//             ,"src":Shirt, "fabricIMG":fabricImg,  "single" : [grey_shirt]
//         },
//         {"fabric": "Green Wool", "brand":"Raymond1", "price":"1200"
//             ,"src":pShirt, "fabricIMG":fabricImg,  "single" : [pink_shirt]
//         },
//         {"fabric": "Green Wool", "brand":"Raymond2", "price":"1199"
//             ,"src":pShirt, "fabricIMG":fabricImg,  "single" : [grey_shirt]
//         },
//         {"fabric": "Red Wool", "brand":"Raymond3", "price":"1199"
//             ,"src":pShirt, "fabricIMG":fabricImg,  "single" : [grey_shirt]
//         },
//         {"fabric": "Silk", "brand":"Raymond4", "price":"1199"
//             ,"src":pShirt, "fabricIMG":fabricImg,  "single" : [grey_shirt]
//         },
//         {"fabric": "Cotton", "brand":"Raymond5", "price":"1199"
//             ,"src":pShirt, "fabricIMG":fabricImg,  "single" : [grey_shirt]
//         },
//         {"fabric": "Synthetic", "brand":"Raymond6", "price":"1199"
//             ,"src":pShirt, "fabricIMG":fabricImg,  "single" : [grey_shirt]
//         }
//     ],
//     "Vest":[
//         {"fabric": "Blue Wool", "brand":"Raymond", "price":"1000"
//             ,"src":vest, "fabricIMG":fabricImg,  "single" : [green_jacket]
//         },
//         {"fabric": "Green Wool", "brand":"Raymond1", "price":"1200"
//             ,"src":vest1, "fabricIMG":fabricImg,  "single" : [red_jacket]
//         },
//         {"fabric": "Green Wool", "brand":"Raymond2", "price":"1199"
//             ,"src":vest, "fabricIMG":fabricImg,  "single" : [green_jacket]
//         },
//         {"fabric": "Red Wool", "brand":"Raymond3", "price":"1199"
//             ,"src":vest1, "fabricIMG":fabricImg,  "single" : [green_jacket]
//         },
//         {"fabric": "Silk", "brand":"Raymond4", "price":"1199"
//             ,"src":vest, "fabricIMG":fabricImg,  "single" : [green_jacket]
//         },
//         {"fabric": "Cotton", "brand":"Raymond5", "price":"1199"
//             ,"src":vest1, "fabricIMG":fabricImg,  "single" : [green_jacket]
//         },
//         {"fabric": "Synthetic", "brand":"Raymond6", "price":"1199"
//             ,"src":vest, "fabricIMG":fabricImg,  "single" : [green_jacket]
//         }
//     ]
// }

export const fabricFilter = [
  {
    type: "Sort Price",
    q: 2,
  },
];

export const StylesFilter = [
  {
    type: "Single Brested",
    name: "Coat",
    pos: "F",
    n: 0,
    place: "Coat",
    attr: [
      [
        { name: "Single Button", img: one_button, value: "1B" },
        { name: "Double Button", img: two_button, value: "2B" },
        { name: "Three Button", img: three_button, value: "3B" },
      ],
    ],
  },
  {
    type: "Double Brested",
    name: "Coat",
    pos: "F",
    n: 0,
    attr: [
      [
        { name: "Four Button", img: four_button, value: "4B" },
        { name: "Six Button", img: six_button, value: "6B" },
      ],
    ],
  },
  {
    type: "Single Brested - Tuxedo",
    name: "Coat",
    pos: "F",
    n: 0,
    action : "Select Tuxedo fabric",
    category : "tuxedo",
    attr: [
      [
        { name: "Single Button", img: one_button_tux, value: "T-1B" },
        { name: "Double Button", img: two_button_tux, value: "T-2B" },
        { name: "Three Button", img: three_button_tux, value: "T-3B" },
      ],
    ],
  },
  {
    type: "Double Brested - Tuxedo",
    name: "Coat",
    pos: "F",
    n: 0,
    action : "Select Tuxedo fabric",
    category : "tuxedo",
    attr: [
      [
        { name: "Four Button", img: four_button_tux, value: "T-4B" },
        { name: "Six Button", img: six_button_tux, value: "T-6B" },
      ],
    ],
  },
  {
    type: "Jodhpuri",
    name: "Coat",
    pos: "F",
    n: 0,
    attr: [
      [
        { name: "Semi Round", img: j_semiround, value: "JH" },
        { name: "Round", img: j_round, value: "JR" },
      ],
    ],
  },
  {
    type: "Back Style",
    name: "Coat",
    pos: "B",
    n: 0,
    attr: [
      [
        { name: "Non Vent", img: non_vent, value: "NV" },
        { name: "Single Vent", img: s_vent, value: "SV" },
        { name: "Side Vent", img: side_vent, value: "DV" },
      ],
    ],
  },
  {
    type: "Lapel",
    name: "Coat",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Notch", img: Notch, value: "N" },
        { name: "Peak", img: peak, value: "P" },
        { name: "Saul", img: saul, value: "S" },
      ],
    ],
  },
  {
    type: "Bottom Pocket",
    name: "Coat",
    pos: "F",
    n: 2,
    attr: [
      [
        { name: "Flap", img: flap, value: "F" },
        { name: "Patch", img: patch, value: "P" },
      ],
    ],
  },
  {
    type: "Upper Pocket",
    name: "Coat",
    pos: "F",
    n: 3,
    attr: [
      [
        { name: "Wallet", img: wallet, value: "W" },
        { name: "Patch", img: upper_pocket_patch, value: "P" },
      ],
    ],
  },
  {
    type: "Stitch",
    name: "Coat",
    pos: "F",
    n: 4,
    attr: [
      [
        { name: "No Stitch", img: stitch, value: "N" },
        { name: "Stitch", img: no_stitch, value: "Y" },
      ],
    ],
  },
  {
    type: "",
    name: "Coat",
    place: "Button",
    pos: "F",
    standalone : true,
    attr: [
    ],
  },
  {
    type: "Style",
    name: "Pant",
    pos: "F",
    n: 0,
    place: "Pant",
    attr: [
      [
        { name: "Non Plates", img: non_plates, value: "F-NP" },
        { name: "Single Plates", img: s_plates, value: "F-SP" },
        { name: "Double Plates", img: d_plates, value: "F-DP" },
      ],
    ],
  },

  {
    type: "Front Pocket",
    name: "Pant",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Cross Pocket", img: pant_CROSSPOCKET, value: "C" },
        { name: "Round Pocket", img: pant_ROUNDPOCKET, value: "R" },
      ],
    ],
  },
  {
    type: "Belt Style",
    name: "Pant",
    pos: "F",
    n: 2,
    attr: [
      [
        { name: "Long Belt", img: pant_LONGBELT, value: "L" },
        { name: "Hook", img: pant_HOOK, value: "H" },
        { name: "Gurkha", img: pant_GURKHA, value: "G" },
      ],
      [
        { name: "Cut Belt", img: pant_CUTBELT, value: "C" }
      ]
    ],
  },

  {
    type: "Back Pocket",
    name: "Pant",
    pos: "B",
    n: 0,
    attr: [
      [
        { name: "Single Pocket Flap", img: pant_FLAPX1, value: "B-F1" },
        { name: "Double Pocket Flap", img: pant_FLAPX2, value: "B-F2" },
        { name: "Double Bone-1", img: pant_DOUBLEBONEX1, value: "B-SP" }
      ],
      [
        { name: "Double Bone-2", img: pant_DOUBLEBONEX2, value: "B-DP" },
        { name: "Single Bone-1", img: pant_SINGLEBONEX1, value: "B-S1" },
        { name: "Single Bone-2", img: pant_SINGLEBONEX2, value: "B-S2" }
      ],
      [
        { name: "No Pocket", img: pant_NONPOCKET, value: "B-NP" },
      ]
    ],
  },

  {
    type: "Collar",
    name: "Shirt",
    pos: "F",
    n: 2,
    place: "Shirt",
    attr: [
      [
        { name: "Standard", img: semi_spread, value: "SD" },
        { name: "Semi Spread", img: semi_spread_n, value: "SS" },
        { name: "Spread", img: spread, value: "S0" },
      ],
      [
        { name: "Button Down", img: button_down, value: "BD" },
        { name: "Mandarin", img: mand, value: "0" },
      ],
    ],
  },
  {
    type: "Cuffs",
    name: "Shirt",
    pos: "F",
    n: 4,
    attr: [
      [
        { name: "Square", img: square, value: "S" },
        { name: "Round", img: ROUND, value: "R" },
        { name: "Notch", img: NOTCH, value: "N" },
      ],
      [
        { name: "2 Button Square", img: square2, value: "X" },
        { name: "2 Button Round", img: ROUND2, value: "Y" },
        { name: "2 Button Notch", img: NOTCH2, value: "Z" },
      ],
      [{ name: "Cufflinks", img: CUFFLINKS, value: "C" }],
    ],
  },
  {
    type: "Pocket",
    name: "Shirt",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "No Pocket", img: shirt_pocket_no, value: "0" },
        { name: "1 Pocket", img: shirt_pocket_1, value: "P1" },
      ],
    ],
  },
  {
    type: "Style",
    name: "Vest",
    pos: "F",
    n: 0,
    place: "Vest Coat",
    attr: [
      [
        { name: "Vest 1", img: s_brested, value: "V1" },
        { name: "Vest 2", img: d_brested, value: "V2" },
        { name: "Vest 3", img: d_brested, value: "V3" },
      ],
    ],
  },
  {
    type: "Vest - Tuxedo",
    name: "Vest",
    pos: "F",
    n: 0,
    category : "tuxedo",
    attr: [
      [
        { name: "Vest 1", img: s_brested, value: "T-V1" },
      ],
    ],
  },
];

export const StylesFilterMob  = [
  {
    type: "Single Brested",
    name: "Coat",
    pos: "F",
    n: 0,
    place: "Coat",
    attr: [
      [
        { name: "Single Button", img: one_button, value: "1B" },
        { name: "Double Button", img: two_button, value: "2B" },
      ],
      [
        { name: "Three Button", img: three_button, value: "3B" },
      ]
    ],
  },
  {
    type: "Double Brested",
    name: "Coat",
    pos: "F",
    n: 0,
    attr: [
      [
        { name: "Four Button", img: four_button, value: "4B" },
        { name: "Six Button", img: six_button, value: "6B" },
      ],
    ],
  },
  {
    type: "Single Brested - Tuxedo",
    name: "Coat",
    pos: "F",
    n: 0,
    action : "Select Tuxedo fabric",
    category : "tuxedo",
    attr: [
      [
        { name: "Single Button", img: one_button_tux, value: "T-1B" },
        { name: "Double Button", img: two_button_tux, value: "T-2B" },
      ],
      [{ name: "Three Button", img: three_button_tux, value: "T-3B" },]
    ],
  },
  {
    type: "Double Brested - Tuxedo",
    name: "Coat",
    pos: "F",
    n: 0,
    action : "Select Tuxedo fabric",
    category : "tuxedo",
    attr: [
      [
        { name: "Four Button", img: four_button_tux, value: "T-4B" },
        { name: "Six Button", img: six_button_tux, value: "T-6B" },
      ],
    ],
  },
  {
    type: "Jodhpuri",
    name: "Coat",
    pos: "F",
    n: 0,
    attr: [
      [
        { name: "Semi Round", img: j_semiround, value: "JH" },
        { name: "Round", img: j_round, value: "JR" },
      ],
    ],
  },
  {
    type: "Back Style",
    name: "Coat",
    pos: "B",
    n: 0,
    attr: [
      [
        { name: "Non Vent", img: non_vent, value: "NV" },
        { name: "Single Vent", img: s_vent, value: "SV" },
      ],
      [{ name: "Side Vent", img: side_vent, value: "DV" },]
    ],
  },
  {
    type: "Lapel",
    name: "Coat",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Notch", img: Notch, value: "N" },
        { name: "Peak", img: peak, value: "P" },
      ],
      [{ name: "Saul", img: saul, value: "S" },]
    ],
  },
  {
    type: "Bottom Pocket",
    name: "Coat",
    pos: "F",
    n: 2,
    attr: [
      [
        { name: "Flap", img: flap, value: "F" },
        { name: "Patch", img: patch, value: "P" },
      ],
    ],
  },
  {
    type: "Upper Pocket",
    name: "Coat",
    pos: "F",
    n: 3,
    attr: [
      [
        { name: "Wallet", img: wallet, value: "W" },
        { name: "Patch", img: upper_pocket_patch, value: "P" },
      ],
    ],
  },
  {
    type: "Stitch",
    name: "Coat",
    pos: "F",
    n: 4,
    attr: [
      [
        { name: "No Stitch", img: stitch, value: "N" },
        { name: "Stitch", img: no_stitch, value: "Y" },
      ],
    ],
  },
  {
    type: "",
    name: "Coat",
    place: "Button",
    pos: "F",
    standalone : true,
    attr: [
    ],
  },
  {
    type: "Style",
    name: "Pant",
    pos: "F",
    n: 0,
    place: "Pant",
    attr: [
      [
        { name: "Non Plates", img: non_plates, value: "F-NP" },
        { name: "Single Plates", img: s_plates, value: "F-SP" },
      ],
      [{ name: "Double Plates", img: d_plates, value: "F-DP" },]
    ],
  },

  {
    type: "Front Pocket",
    name: "Pant",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Cross Pocket", img: pant_CROSSPOCKET, value: "C" },
        { name: "Round Pocket", img: pant_ROUNDPOCKET, value: "R" },
      ],
    ],
  },
  {
    type: "Belt Style",
    name: "Pant",
    pos: "F",
    n: 2,
    attr: [
      [
        { name: "Long Belt", img: pant_LONGBELT, value: "L" },
        { name: "Hook", img: pant_HOOK, value: "H" },
      ],
      [
        { name: "Gurkha", img: pant_GURKHA, value: "G" },
        { name: "Cut Belt", img: pant_CUTBELT, value: "C" }
      ]
    ],
  },

  {
    type: "Back Pocket",
    name: "Pant",
    pos: "B",
    n: 0,
    attr: [
      [
        { name: "Single Pocket Flap", img: pant_FLAPX1, value: "B-F1" },
        { name: "Double Pocket Flap", img: pant_FLAPX2, value: "B-F2" },
      ],
      [
        { name: "Double Bone-1", img: pant_DOUBLEBONEX1, value: "B-SP" },
        { name: "Double Bone-2", img: pant_DOUBLEBONEX2, value: "B-DP" },
      ],
      [
        { name: "Single Bone-1", img: pant_SINGLEBONEX1, value: "B-S1" },
        { name: "Single Bone-2", img: pant_SINGLEBONEX2, value: "B-S2" }
      ],
      [
        { name: "No Pocket", img: pant_NONPOCKET, value: "B-NP" },
      ]
    ],
  },

  {
    type: "Collar",
    name: "Shirt",
    pos: "F",
    n: 2,
    place: "Shirt",
    attr: [
      [
        { name: "Standard", img: semi_spread, value: "SD" },
        { name: "Semi Spread", img: semi_spread_n, value: "SS" },
      ],
      [
        { name: "Spread", img: spread, value: "S0" },
        { name: "Button Down", img: button_down, value: "BD" },
      ],
      [{ name: "Mandarin", img: mand, value: "0" },]
    ],
  },
  {
    type: "Cuffs",
    name: "Shirt",
    pos: "F",
    n: 4,
    attr: [
      [
        { name: "Square", img: square, value: "S" },
        { name: "Round", img: ROUND, value: "R" },
      ],
      [
        { name: "Notch", img: NOTCH, value: "N" },
        { name: "2 Button Square", img: square2, value: "X" },
      ],
      [
        { name: "2 Button Round", img: ROUND2, value: "Y" },
        { name: "2 Button Notch", img: NOTCH2, value: "Z" },
      ],
      [{ name: "Cufflinks", img: CUFFLINKS, value: "C" }],
    ],
  },
  {
    type: "Pocket",
    name: "Shirt",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "No Pocket", img: shirt_pocket_no, value: "0" },
        { name: "1 Pocket", img: shirt_pocket_1, value: "P1" },
      ],
    ],
  },
  {
    type: "Style",
    name: "Vest",
    pos: "F",
    n: 0,
    place: "Vest Coat",
    attr: [
      [
        { name: "Vest 1", img: s_brested, value: "V1" },
        { name: "Vest 2", img: d_brested, value: "V2" },
      ],
      [{ name: "Vest 3", img: d_brested, value: "V3" },]
    ],
  },
  {
    type: "Vest - Tuxedo",
    name: "Vest",
    pos: "F",
    n: 0,
    category : "tuxedo",
    attr: [
      [
        { name: "Vest 1", img: s_brested, value: "T-V1" },
      ],
    ],
  },
];

///// only for formal

export const StylesFilter_formal = [
  {
    type: "Collar",
    name: "Shirt",
    pos: "F",
    n: 2,
    place: "Shirt",
    attr: [
      [
        { name: "Standard", img: semi_spread, value: "SD" },
        { name: "Semi Spread", img: semi_spread_n, value: "SS" },
        { name: "Spread", img: spread, value: "S0" },
      ],
      [
        { name: "Button Down", img: button_down, value: "BD" },
        { name: "Round", img: round_collar, value: "R0" },
        { name: "Mandarin", img: mand, value: "0" },
      ],
    ],
  },
  {
    type: "Sleeve",
    name: "Shirt",
    pos: "F",
    n: 3,
    attr: [
      [
        { name: "Full Sleevel", img: shirt_full_sleeve, value: "F" },
        { name: "Half Sleeve", img: shirt_half_sleeve, value: "H" },
      ],
    ],
  },
  {
    type: "Cuffs",
    name: "Shirt",
    pos: "F",
    n: 4,
    attr: [
      [
        { name: "Square", img: square, value: "S" },
        { name: "Round", img: ROUND, value: "R" },
        { name: "Notch", img: NOTCH, value: "N" },
      ],
      [
        { name: "2 Button Square", img: square2, value: "X" },
        { name: "2 Button Round", img: ROUND2, value: "Y" },
        { name: "2 Button Notch", img: NOTCH2, value: "Z" },
      ],
      [{ name: "Cufflinks", img: CUFFLINKS, value: "C" }],
    ],
  },
  {
    type: "Pocket",
    name: "Shirt",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "No Pocket", img: shirt_pocket_no, value: "0" },
        { name: "1 Pocket", img: shirt_pocket_1, value: "P1" },
      ],
    ],
  },
  {
    type: "Style",
    name: "Shirt",
    pos: "B",
    n: 0,
    attr: [
      [
        { name: "Side Cut", img: shirt_side_cut, value: "K" },
        { name: "Apple", img: shirt_apple_cut, value: "A" },
        { name: "Straight", img: shirt_straight_cut, value: "B" },
      ],
    ],
  },
  
  {
    type: "Style",
    name: "Pant",
    pos: "F",
    n: 0,
    place: "Pant",
    attr: [
      [
        { name: "Non Plates", img: non_plates, value: "F-NP" },
        { name: "Single Plates", img: s_plates, value: "F-SP" },
        { name: "Double Plates", img: d_plates, value: "F-DP" },
      ],
    ],
  },

  {
    type: "Front Pocket",
    name: "Pant",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Cross Pocket", img: pant_CROSSPOCKET, value: "C" },
        { name: "Round Pocket", img: pant_ROUNDPOCKET, value: "R" },
      ],
    ],
  },
  {
    type: "Belt Style",
    name: "Pant",
    pos: "F",
    n: 2,
    attr: [
      [
        { name: "Long Belt", img: pant_LONGBELT, value: "L" },
        { name: "Hook", img: pant_HOOK, value: "H" },
        { name: "Gurkha", img: pant_GURKHA, value: "G" },
      ],
      [
        { name: "Cut Belt", img: pant_CUTBELT, value: "C" }
      ]
    ],
  },

  {
    type: "Back Pocket",
    name: "Pant",
    pos: "B",
    n: 0,
    attr: [
      [
        { name: "Single Pocket Flap", img: pant_FLAPX1, value: "B-F1" },
        { name: "Double Pocket Flap", img: pant_FLAPX2, value: "B-F2" },
        { name: "Double Bone-1", img: pant_DOUBLEBONEX1, value: "B-SP" }
      ],
      [
        { name: "Double Bone-2", img: pant_DOUBLEBONEX2, value: "B-DP" },
        { name: "Single Bone-1", img: pant_SINGLEBONEX1, value: "B-S1" },
        { name: "Single Bone-2", img: pant_SINGLEBONEX2, value: "B-S2" }
      ],
      [
        { name: "No Pocket", img: pant_NONPOCKET, value: "B-NP" },
      ]
    ],
  },


];

export const StylesFilterMob_formal = [
  {
    type: "Shirt Collar",
    name: "Shirt",
    pos: "F",
    n: 2,
    place: "Shirt",
    attr: [
      [
        { name: "Standard", img: semi_spread, value: "SD" },
        { name: "Semi Spread", img: semi_spread_n, value: "SS" },
      ],
      [
        { name: "Spread", img: spread, value: "S0" },
        { name: "Button Down", img: button_down, value: "BD" },
      ],
      [{ name: "Round", img: round_collar, value: "R0" },
      { name: "Mandarin", img: mand, value: "0" }],
    ],
  },
  {
    type: "Shirt Cuffs",
    name: "Shirt",
    pos: "F",
    n: 4,
    attr: [
      [
        { name: "Square", img: square, value: "S" },
        { name: "Round", img: ROUND, value: "R" },
      ],
      [
        { name: "Notch", img: NOTCH, value: "N" },
        { name: "2 Button Square", img: square2, value: "X" },
      ],
      [
        { name: "2 Button Round", img: ROUND2, value: "Y" },
        { name: "2 Button Notch", img: NOTCH2, value: "Z" },
      ],
      [{ name: "Cufflinks", img: CUFFLINKS, value: "C" }],
    ],
  },
  {
    type: "Shirt Pocket",
    name: "Shirt",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "No Pocket", img: shirt_pocket_no, value: "0" },
        { name: "1 Pocket", img: shirt_pocket_1, value: "P1" },
      ],
    ],
  },
  {
    type: "Style",
    name: "Shirt",
    pos: "B",
    n: 0,
    attr: [
      [
        { name: "Side Cut", img: shirt_side_cut, value: "K" },
        { name: "Apple", img: shirt_apple_cut, value: "A" },
      ],
      [{ name: "Straight", img: shirt_straight_cut, value: "B" }]
    ],
  },
  {
    type: "Sleeve",
    name: "Shirt",
    pos: "F",
    n: 3,
    attr: [
      [
        { name: "Full Sleevel", img: shirt_full_sleeve, value: "F" },
        { name: "Half Sleeve", img: shirt_half_sleeve, value: "H" },
      ],
    ],
  },
  {
    type: "Plates",
    name: "Pant",
    pos: "F",
    n: 0,
    place: "Pant",
    attr: [
      [
        { name: "Non Plates", img: non_plates, value: "F-NP" },
        { name: "Single Plates", img: s_plates, value: "F-SP" },
      ],
      [{ name: "Double Plates", img: d_plates, value: "F-DP" }],
    ],
  },

  {
    type: "Front Pocket",
    name: "Pant",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Cross Pocket", img: pant_CROSSPOCKET, value: "C" },
        { name: "Round Pocket", img: pant_ROUNDPOCKET, value: "R" },
      ],
    ],
  },
  {
    type: "Belt Style",
    name: "Pant",
    pos: "F",
    n: 2,
    attr: [
      [
        { name: "Long Belt", img: pant_LONGBELT, value: "L" },
        { name: "Hook", img: pant_HOOK, value: "H" },

      ],
      [
        { name: "Gurkha", img: pant_GURKHA, value: "G" },
        { name: "Cut Belt", img: pant_CUTBELT, value: "C" }
      ]
    ],
  },
  {
    type: "Back Pocket",
    name: "Pant",
    pos: "B",
    n: 0,
    attr: [
      [
        { name: "Single Pocket Flap", img: pant_FLAPX1, value: "B-F1" },
        { name: "Double Pocket Flap", img: pant_FLAPX2, value: "B-F2" },

      ],
      [
        { name: "Double Bone-1", img: pant_DOUBLEBONEX1, value: "B-SP" },
        { name: "Double Bone-2", img: pant_DOUBLEBONEX2, value: "B-DP" },
      ],
      [
        { name: "Single Bone-1", img: pant_SINGLEBONEX1, value: "B-S1" },
        { name: "Single Bone-2", img: pant_SINGLEBONEX2, value: "B-S2" }
      ],
      [
        { name: "No Pocket", img: pant_NONPOCKET, value: "B-NP" },
      ]
    ],
  },

];

export const StylesFilter_kurta = [
    {
      type: "Button",
      name: "Coat",
      place: "Coat",
      pos: "F",
      standalone : true,
      attr: [],
    },
    {
      type: "Single Brested",
      name: "Coat",
      pos: "F",
      n: 0,
      attr: [
        [
          { name: "Single Button", img: one_button, value: "1B" },
          { name: "Double Button", img: two_button, value: "2B" }
        ],
      ],
    },
    {
      type: "Tuxedo",
      name: "Coat",
      pos: "F",
      n: 0,
      attr: [
        [
          { name: "Single Button", img: one_button_tux, value: "T-1B" },
          { name: "Double Button", img: two_button_tux, value: "T-2B" }
        ],
      ],
    },
    {
      type: "Lapel",
      name: "Coat",
      pos: "F",
      n: 1,
      attr: [
        [
          { name: "Notch", img: Notch, value: "N" },
          { name: "Peak", img: peak, value: "P" },
        ],
      ],
    },
    {
      type: "Jodhpuri",
      name: "Coat",
      pos: "F",
      n: 0,
      attr: [
        [
          { name: "Semi Round", img: j_semiround, value: "JH" },
          { name: "Round", img: j_round, value: "JR" },
          { name: "Straight", img: j_straight, value: "JS" },
        ],
        [
          { name: "Open Coat", img: j_open, value: "JO" }
        ]
      ],
    },
    {
      type: "Upper Pocket",
      name: "Coat",
      pos: "F",
      n: 3,
      attr: [
        [
          { name: "No Pocket", img: sadri_NOVPOCKET, value: "0" },
          { name: "Pocket", img: sadri_VPOCKET, value: "1" },
        ],
      ],
    },
    {
      type: "Back Style",
      name: "Coat",
      pos: "B",
      n: 0,
      attr: [
        [
          { name: "Non Vent", img: non_vent, value: "NV" },
          { name: "Single Vent", img: s_vent, value: "SV" },
          { name: "Side Vent", img: side_vent, value: "DV" },
        ],
      ],
    },
  ///////////////////// coat end

  //////////////////// Kurta
  {
    type: "Button",
    name: "Kurta",
    place: "Kurta",
    pos: "F",
    standalone : true,
    attr: [],
  },
  {
    type: "Length",
    name: "Kurta",
    pos: "F",
    n: 10,
    attr: [
      [
        { name: "Long", img: kurta_LENLONG, value: "K" },
        { name: "Short", img: kurta_LENSHORT, value: "P" },
      ],
    ],
  },
  {
    type: "Bottom Cut",
    name: "Kurta",
    pos: "F",
    n: 0,
    attr: [
      [
        { name: "Round", img: kurta_BOTTOCUTROUND, value: "R" },
        { name: "Straight", img: kurta_BOTTOMCUTSQURE, value: "S" },
      ],
    ],
  },

  {
    type: "Neck Placket",
    name: "Kurta",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Notch", img: kurta_NOTCHPLACKET, value: "NS" },
        { name: "Square", img: kurta_SQUREPLACKET, value: "QS" },
      ]
    ],
  },

  {
    type: "Pocket",
    name: "Kurta",
    pos: "F",
    n: 2,
    attr: [
      [
        { name: "No Pocket", img: kurta_NOPOCKET, value: "00" },
        { name: "1 Pocket", img: kurta_1POCKET, value: "01" },
        { name: "2 Pocket", img: kurta_2POCKET, value: "11" },
      ]
    ],
  },

  {
    type: "Pocket Type",
    name: "Kurta",
    pos: "F",
    n: 3,
    attr: [
      [
        { name: "Round", img: kurta_ROUNDPOCKET, value: "R" },
        { name: "Notch", img: kurta_NOTCHPOCKET, value: "N" },
        { name: "Square", img: kurta_SQUREPOCKET, value: "S" },
      ]
    ],
  },

  {
    type: "Flap",
    name: "Kurta",
    pos: "F",
    n: 4,
    attr: [
      [
        { name: "No Flap", img: kurta_NOFLAP, value: "0" },
        { name: "Flap", img: kurta_2FLAP, value: "1" },
      ]
    ],
  },
  {
    type: "Flap Type",
    name: "Kurta",
    pos: "F",
    n: 5,
    attr: [
      [
        { name: "Round", img: kurta_ROUNDFLAP, value: "R" },
        { name: "Notch", img: kurta_NOTCHFLAP, value: "N" },
        { name: "Square", img: kurta_SQUREFLAP, value: "S" },
      ]
    ],
  },

  {
    type: "Shoulder Epaulette",
    name: "Kurta",
    pos: "F",
    n: 6,
    attr: [
      [
        { name: "NO", img: kurta_NOShoulderEpaulette, value: "0" },
        { name: "YES", img: kurta_ShoulderEpaulette, value: "SE" }
      ]
    ],
  },

  {
    type: "Collar",
    name: "Kurta",
    pos: "F",
    n: 7,
    sub: "Chinese Collar",
    attr: [
      [
        { name: "Round", img: kurta_ROUNDNECK, value: "CA" },
        { name: "MANDARIN", img: kurta_CHINACOLLAR, value: "CM" },
        { name: "STAND COLLAR", img: kurta_MANDARINCOLLAR, value: "CC" },
      ]
    ]
  },
  {
    type: "Collar",
    name: "Kurta",
    pos: "F",
    n: 7,
    sub: "Shirt Collar",
    hdr: 1,
    attr: [

      [
        { name: "ROUND", img: kurta_ROUNDCOLLAR, value: "CR" },
        { name: "BUTTON DOWN", img: kurta_BUTTONDOWNCOLLAR, value: "CB" },
        { name: "STANDARD", img: kurta_STANDERDCOLLAR, value: "CT" },
      ],
      [
        { name: "SEMI SPREAD", img: kurta_SEMISPREAD, value: "CE" },
        { name: "SPREAD", img: kurta_SPREADCOLLAR, value: "CS" },
      ]
    ],
  },
  {
    type: "Sleeve",
    name: "Kurta",
    pos: "F",
    n: 8,
    attr: [
      [
        { name: "No Cuff", img: kurta_NONCUFFSLEEVE, value: "SN" },
        { name: "Cuff", img: kurta_CUFFSLEEVE, value: "SC" }
      ]
    ],
  },
  {
    type: "Cuff Style",
    name: "Kurta",
    pos: "F",
    n: 9,
    attr: [
      [
        { name: "Square", img: square, value: "US1" },
        { name: "Round", img: ROUND, value: "UR1" },
        { name: "Notch", img: NOTCH, value: "UN1" },
      ],
      [
        { name: "2 Square", img: square2, value: "US2" },
        { name: "2 Round", img: ROUND2, value: "UR2" },
        { name: "2 Notch", img: NOTCH2, value: "UN2" },
      ]
    ],

  },

  /////// Kurta end

  //// Pajama 

  {
    type: "Style",
    name: "Pajama",
    pos: "F",
    n: 0,
    place: "Pajama",
    attr: [
      [
        { name: "Pant", img: pajama_PANTPAJAMA, value: "PP" },
        { name: "Salwar", img: pajama_SALWAR, value: "PS" },
        { name: "Churidar", img: pajama_CHURIDAR, value: "PC" },
      ],
      [
        { name: "Pajama", img: pajama_PAJAMA, value: "PJ" },
        { name: "Dhoti", img: pajama_DHOTI, value: "PD" },
        { name: "Patiala", img: pajama_PATIALA, value: "PT" }
      ],
      [
        { name: "Aligarhi", img: pajama_ALIGARHI, value: "PA" },
        { name: "Belbottom", img: pajama_BELLBOTTOM, value: "PB" },
      ]
    ],

  },
  {
    type: "Belt",
    name: "Pajama",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Elastic", img: pajama_elastic, value: "E" },
        { name: "Rope", img: pajama_rope, value: "R" },
      ]
    ],

  },
  //// end of Pajama

  /// start Sadri
  {
    type: "Button",
    name: "Sadri",
    place: "Sadri",
    pos: "F",
    standalone : true,
    attr: [],
  },
  {
    type: "Style",
    name: "Sadri",
    pos: "F",
    n: 0,
    attr: [
      [
        { name: "Essential Nehru", img: sadri_ESSENTIALNEHRU, value: "SR" },
        { name: "Officer", img: sadri_OFFICER, value: "EE" },
        { name: "Royal Wrap", img: sadri_ROYALWRAP, value: "FF" },
      ],
      [
        { name: "Avant Edge", img: sadri_AVANTEDGE, value: "DD" },
        { name: "Ranger", img: sadri_RANGER, value: "AA" },
        { name: "Elite Minimal", img: sadri_ELITEMINIMAL, value: "BB" },
      ],
      [
        { name: "Metro Utility", img: sadri_METROUTILITY, value: "CC" },
        { name: "Signature Curve", img: sadri_SIGNATURECURVE, value: "RR" },
        { name: "Command", img: sadri_COMMAND, value: "SS" },
      ],
      [
        { name: "Modern Royal", img: sadri_MODERNROYAL, value: "GG" },
        { name: "Royal Asym", img: sadri_ROYALASYM, value: "HH" },
        { name: "Imperial Seamless", img: sadri_IMPERIALSEAMLESS, value: "KK" },
      ],
      [
        { name: "Heritage", img: sadri_HERITAGE, value: "L" },
        { name: "Classic lapel", img: sadri_CLASSICLAP, value: "M" },
        { name: "Urban Safari", img: sadri_URBANSAFARI, value: "N" },
      ]
    ],

  },
  {
    type: "Pocket",
    name: "Sadri",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "No Pocket", img: sadri_NOVPOCKET, value: "0" },
        { name: "Pocket", img: sadri_VPOCKET, value: "1" },
      ]

    ],
  },
];
/////// end of Sadri

export const StylesFilterMob_kurta = [
  {
    type: "Button",
    name: "Coat",
    place: "Coat",
    pos: "F",
    standalone : true,
    attr: [],
  },
  {
    type: "Single Brested",
    name: "Coat",
    pos: "F",
    n: 0,
    attr: [
      [
        { name: "Single Button", img: one_button, value: "1B" },
        { name: "Double Button", img: two_button, value: "2B" }
      ],
    ],
  },
  {
    type: "Tuxedo",
    name: "Coat",
    pos: "F",
    n: 0,
    attr: [
      [
        { name: "Single Button", img: one_button_tux, value: "T-1B" },
        { name: "Double Button", img: two_button_tux, value: "T-2B" }
      ],
    ],
  },
  {
    type: "Lapel",
    name: "Coat",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Notch", img: Notch, value: "N" },
        { name: "Peak", img: peak, value: "P" },
      ],
    ],
  },
  {
    type: "Jodhpuri",
    name: "Coat",
    pos: "F",
    n: 0,
    attr: [
      [
        { name: "Semi Round", img: j_semiround, value: "JH" },
        { name: "Round", img: j_round, value: "JR" },
      ],
      [{ name: "Straight", img: j_straight, value: "JS" },
        { name: "Open Jodhpuri", img: j_open, value: "JO" },
      ]
    ],
  },
  {
    type: "Upper Pocket",
    name: "Coat",
    pos: "F",
    n: 3,
    attr: [
      [
        { name: "No Pocket", img: sadri_NOVPOCKET, value: "0" },
        { name: "Pocket", img: sadri_VPOCKET, value: "1" },
      ],
    ],
  },
  {
    type: "Back Style",
    name: "Coat",
    pos: "B",
    n: 0,
    attr: [
      [
        { name: "Non Vent", img: non_vent, value: "NV" },
        { name: "Single Vent", img: s_vent, value: "1V" },
      ],
      [{ name: "Side Vent", img: side_vent, value: "2V" }]
    ],
  },
  ///////////////////// coat end

  //////////////////// Kurta
  {
    type: "Button",
    name: "Kurta",
    place: "Kurta",
    pos: "F",
    standalone : true,
    attr: [],
  },
  {
    type: "Length",
    name: "Kurta",
    pos: "F",
    n: 10,
    attr: [
      [
        { name: "Long", img: kurta_LENLONG, value: "K" },
        { name: "Short", img: kurta_LENSHORT, value: "P" },
      ],
    ],
  },
  {
    type: "Bottom Cut",
    name: "Kurta",
    pos: "F",
    n: 0,
    attr: [
      [
        { name: "Round", img: kurta_BOTTOCUTROUND, value: "R" },
        { name: "Straight", img: kurta_BOTTOMCUTSQURE, value: "S" },
      ],
    ],
  },

  {
    type: "Neck Placket",
    name: "Kurta",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Notch", img: kurta_NOTCHPLACKET, value: "NS" },
        { name: "Square", img: kurta_SQUREPLACKET, value: "QS" },
      ]
    ],
  },

  {
    type: "Pocket",
    name: "Kurta",
    pos: "F",
    n: 2,
    attr: [
      [
        { name: "No Pocket", img: kurta_NOPOCKET, value: "00" },
        { name: "1 Pocket", img: kurta_1POCKET, value: "01" },
      ],
      [{ name: "2 Pocket", img: kurta_2POCKET, value: "11" },]
    ],
  },

  {
    type: "Pocket Type",
    name: "Kurta",
    pos: "F",
    n: 3,
    attr: [
      [
        { name: "Round", img: kurta_ROUNDPOCKET, value: "R" },
        { name: "Notch", img: kurta_NOTCHPOCKET, value: "N" },
      ],
      [{ name: "Square", img: kurta_SQUREPOCKET, value: "S" },]
    ],
  },

  {
    type: "Flap",
    name: "Kurta",
    pos: "F",
    n: 4,
    attr: [
      [
        { name: "No Flap", img: kurta_NOFLAP, value: "0" },
        { name: "Flap", img: kurta_2FLAP, value: "1" },
      ]
    ],
  },
  {
    type: "Flap Type",
    name: "Kurta",
    pos: "F",
    n: 5,
    attr: [
      [
        { name: "Round", img: kurta_ROUNDFLAP, value: "R" },
        { name: "Notch", img: kurta_NOTCHFLAP, value: "N" },
      ],
      [{ name: "Square", img: kurta_SQUREFLAP, value: "S" },]
    ],
  },

  {
    type: "Shoulder Epaulette",
    name: "Kurta",
    pos: "F",
    n: 6,
    attr: [
      [
        { name: "NO", img: kurta_NOShoulderEpaulette, value: "0" },
        { name: "YES", img: kurta_ShoulderEpaulette, value: "SE" }
      ]
    ],
  },

  {
    type: "Collar",
    name: "Kurta",
    pos: "F",
    n: 7,
    sub: "Chinese Collar",
    attr: [
      [
        { name: "Round", img: kurta_ROUNDNECK, value: "CA" },
        { name: "MANDARIN", img: kurta_CHINACOLLAR, value: "CM" },
      ],
      [{ name: "STAND COLLAR", img: kurta_MANDARINCOLLAR, value: "CC" },]
    ]
  },
  {
    type: "Collar",
    name: "Kurta",
    pos: "F",
    n: 7,
    sub: "Shirt Collar",
    hdr: 1,
    attr: [

      [
        { name: "ROUND", img: kurta_ROUNDCOLLAR, value: "CR" },
        { name: "BUTTON DOWN", img: kurta_BUTTONDOWNCOLLAR, value: "CB" },
      ],
      [
        { name: "STANDARD", img: kurta_STANDERDCOLLAR, value: "CT" },
        { name: "SEMI SPREAD", img: kurta_SEMISPREAD, value: "CE" },
      ],
      [{ name: "SPREAD", img: kurta_SPREADCOLLAR, value: "CS" },]
    ],
  },
  {
    type: "Sleeve",
    name: "Kurta",
    pos: "F",
    n: 8,
    attr: [
      [
        { name: "No Cuff", img: kurta_NONCUFFSLEEVE, value: "SN" },
        { name: "Cuff", img: kurta_CUFFSLEEVE, value: "SC" }
      ]
    ],
  },
  {
    type: "Cuff Style",
    name: "Kurta",
    pos: "F",
    n: 9,
    attr: [
      [
        { name: "Square", img: square, value: "US1" },
        { name: "Round", img: ROUND, value: "UR1" },
        
      ],
      [
        { name: "Notch", img: NOTCH, value: "UN1" },
        { name: "2 Square", img: square2, value: "US2" },
      ],
      [
        { name: "2 Round", img: ROUND2, value: "UR2" },
        { name: "2 Notch", img: NOTCH2, value: "UN2" },
      ]
    ],

  },

  /////// Kurta end

  //// Pajama 

  {
    type: "Style",
    name: "Pajama",
    pos: "F",
    n: 0,
    place: "Pajama",
    attr: [
      [
        { name: "Pant", img: pajama_PANTPAJAMA, value: "PP" },
        { name: "Salwar", img: pajama_SALWAR, value: "PS" },
        { name: "Churidar", img: pajama_CHURIDAR, value: "PC" },
      ],
      [
        { name: "Pajama", img: pajama_PAJAMA, value: "PJ" },
        { name: "Dhoti", img: pajama_DHOTI, value: "PD" },
        { name: "Patiala", img: pajama_PATIALA, value: "PT" }
      ],
      [
        { name: "Aligarhi", img: pajama_ALIGARHI, value: "PA" },
        { name: "Belbottom", img: pajama_BELLBOTTOM, value: "PB" },
      ]
    ],

  },
  {
    type: "Belt",
    name: "Pajama",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Elastic", img: pajama_elastic, value: "E" },
        { name: "Rope", img: pajama_rope, value: "R" },
      ]
    ],

  },
  //// end of Pajama

  /// start Sadri
  {
    type: "Button",
    name: "Sadri",
    place: "Sadri",
    pos: "F",
    standalone : true,
    attr: [],
  },
  {
    type: "Style",
    name: "Sadri",
    pos: "F",
    n: 0,
    attr: [
        [
          { name: "Essential Nehru", img: sadri_ESSENTIALNEHRU, value: "SR" },
          { name: "Officer", img: sadri_OFFICER, value: "EE" },
        ],
        [
          { name: "Royal Wrap", img: sadri_ROYALWRAP, value: "FF" },
          { name: "Avant Edge", img: sadri_AVANTEDGE, value: "DD" },
        ],
        [
          { name: "Ranger", img: sadri_RANGER, value: "AA" },
          { name: "Elite Minimal", img: sadri_ELITEMINIMAL, value: "BB" },
        ],
        [
          { name: "Metro Utility", img: sadri_METROUTILITY, value: "CC" },
          { name: "Signature Curve", img: sadri_SIGNATURECURVE, value: "RR" },
        ],
        [
          { name: "Command", img: sadri_COMMAND, value: "SS" },
          { name: "Modern Royal", img: sadri_MODERNROYAL, value: "GG" },
        ],
        [
          { name: "Royal Asym", img: sadri_ROYALASYM, value: "HH" },
          { name: "Imperial Seamless", img: sadri_IMPERIALSEAMLESS, value: "KK" },
        ],
        [
          { name: "Heritage", img: sadri_HERITAGE, value: "L" },
          { name: "Classic lapel", img: sadri_CLASSICLAP, value: "M" },
        ],
        [
          { name: "Urban Safari", img: sadri_URBANSAFARI, value: "N" }
        ]
    ],

  },
  {
    type: "Pocket",
    name: "Sadri",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "No Pocket", img: sadri_NOVPOCKET, value: "0" },
        { name: "Pocket", img: sadri_VPOCKET, value: "1" },
      ]

    ],
  },
];

export const StylesFilter_Blazer = [
  {
    type: "Single Brested",
    name: "Coat",
    pos: "F",
    n: 0,
    place: "Coat",
    attr: [
      [
        { name: "Single Button", img: one_button, value: "1B" },
        { name: "Double Button", img: two_button, value: "2B" },
        { name: "Three Button", img: three_button, value: "3B" },
      ],
    ],
  },
  {
    type: "Double Brested",
    name: "Coat",
    pos: "F",
    n: 0,
    attr: [
      [
        { name: "Four Button", img: four_button, value: "4B" },
        { name: "Six Button", img: six_button, value: "6B" },
      ],
    ],
  },
  {
    type: "Jodhpuri",
    name: "Coat",
    pos: "F",
    n: 0,
    attr: [
      [
        { name: "Semi Round", img: j_semiround, value: "JH" },
        { name: "Round", img: j_round, value: "JR" },
        { name: "Straight", img: j_straight, value: "JS" },
      ],
    ],
  },
  {
    type: "Back Style",
    name: "Coat",
    pos: "B",
    n: 0,
    attr: [
      [
        { name: "Non Vent", img: non_vent, value: "NV" },
        { name: "Single Vent", img: s_vent, value: "1V" },
        { name: "Side Vent", img: side_vent, value: "2V" },
      ],
    ],
  },
  {
    type: "Lapel",
    name: "Coat",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Notch", img: Notch, value: "N" },
        { name: "Peak", img: peak, value: "P" },
      ],
    ],
  },
  {
    type: "Pocket",
    name: "Coat",
    pos: "F",
    n: 2,
    attr: [
      [
        { name: "Flap", img: flap, value: "FL" },
        { name: "Patch", img: patch, value: "PT" },
      ],
    ],
  },
  {
    type: "Stitch",
    name: "Coat",
    pos: "F",
    n: 3,
    attr: [
      [
        { name: "No Stitch", img: stitch, value: "" },
        { name: "Stitch", img: no_stitch, value: "Y" },
      ],
    ],
  },
]

export const StylesFilterMob_Blazer = [
  {
    type: "Single Brested",
    name: "Coat",
    pos: "F",
    n: 0,
    place: "Coat",
    attr: [
      [
        { name: "Single Button", img: one_button, value: "1B" },
        { name: "Double Button", img: two_button, value: "2B" },
      ],

      [{ name: "Three Button", img: three_button, value: "3B" }],
    ],
  },
  {
    type: "Double Brested",
    name: "Coat",
    pos: "F",
    n: 0,
    attr: [
      [
        { name: "Four Button", img: four_button, value: "4B" },
        { name: "Six Button", img: six_button, value: "6B" },
      ],
    ],
  },
  {
    type: "Jodhpuri",
    name: "Coat",
    pos: "F",
    n: 0,
    attr: [
      [
        { name: "Semi Round", img: j_semiround, value: "JH" },
        { name: "Round", img: j_round, value: "JR" },
      ],
      [{ name: "Straight", img: j_straight, value: "JS" }],
    ],
  },
  {
    type: "Back Style",
    name: "Coat",
    pos: "B",
    n: 0,
    attr: [
      [
        { name: "Non Vent", img: non_vent, value: "NV" },
        { name: "Single Vent", img: s_vent, value: "1V" },
      ],
      [{ name: "Side Vent", img: side_vent, value: "2V" }],
    ],
  },
  {
    type: "Lapel",
    name: "Coat",
    pos: "F",
    n: 1,
    attr: [
      [
        { name: "Notch", img: Notch, value: "N" },
        { name: "Peak", img: peak, value: "P" },
      ],
    ],
  },
  {
    type: "Coat Pocket",
    name: "Coat",
    pos: "F",
    n: 2,
    attr: [
      [
        { name: "Flap", img: flap, value: "FL" },
        { name: "Patch", img: patch, value: "PT" },
      ],
    ],
  },
  ,
  {
    type: "Stitch",
    name: "Coat",
    pos: "F",
    n: 3,
    attr: [
      [
        { name: "No Stitch", img: flap, value: "" },
        { name: "Stitch", img: patch, value: "Y" },
      ],
    ],
  },
]
export const defaultStyle = {
  Coat: {
    F: ["1B", "N", "FL", "1"],
    B: ["NV"],
  },
  Pant: {
    F: ["F-NP"],
    B: ["B-SP"],
  },
  Vest: {
    F: ["SB"],
  },
  Shirt: {
    F: ["BASE", "0", "0", "C", "SLEEV"],
  },
};

export const PreFilter = [
  {
    name: "Clothing",
    items: [
      "Suits",
      "Shirt",
      "Uniform",
      "Vest",
      "Formal Wear",
      "Jodhpuri",
      "Blazer",
      "Kurtas",
      "Sharwani",
      "Pant",
    ],
  },
];

export const Sample_preset = [
  {
    name: "Wedding Tux",
    image: [P1, P2],
    price: "11999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Women Formals",
    image: [P2, P1],
    price: "120",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Blue Suede",
    image: [P3, P2],
    price: "10999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Wedding Tux",
    image: [P1, P3],
    price: "9999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Women Formals",
    image: [P2, P3],
    price: "8999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Blue Suede",
    image: [P3, P2],
    price: "7999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Wedding Tux",
    image: [P1, P2],
    price: "6999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Wedding Tux",
    image: [P1, P2],
    price: "9999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },

  {
    name: "atk Tux",
    image: [P1, P2],
    price: "11999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "atk Formals",
    image: [P2, P1],
    price: "120",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "atk Suede",
    image: [P3, P2],
    price: "10999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "atk Tux",
    image: [P1, P3],
    price: "9999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "atk Formals",
    image: [P2, P3],
    price: "8999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "atk Suede",
    image: [P3, P2],
    price: "7999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "atk Tux",
    image: [P1, P2],
    price: "6999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "atk Tux",
    image: [P1, P2],
    price: "9999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Wedding Tux",
    image: [P1, P2],
    price: "11999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Women Formals",
    image: [P2, P1],
    price: "120",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Blue Suede",
    image: [P3, P2],
    price: "10999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Wedding Tux",
    image: [P1, P3],
    price: "9999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Women Formals",
    image: [P2, P3],
    price: "8999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Blue Suede",
    image: [P3, P2],
    price: "7999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Wedding Tux",
    image: [P1, P2],
    price: "6999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
  {
    name: "Wedding Tux",
    image: [P1, P2],
    price: "9999",
    des: "weionfoierwnfio",
    fabric: "Cotton",
    brand: "Raymond",
    type: 0,
  },
];

export const Body_config = {
    "formal": [
        {
            id : 0,
            body : formal_body2,
            hands : hands2,
            wrist : wrist2,
            property : "fair"
        },
        {
            id : 1,
            body : formal_body,
            hands : hands,
            wrist : wrist,
            property : "old"
        },
        {
            id : 2,
            body : formal_body1,
            hands : hands1,
            wrist : wrist1,
            property : "dark"
        },
    ],
    "shirt" :[
        {
            id : 0,
            body : formal_body2,
            hands : hands2,
            wrist : wrist2,
            property : "fair"
        },
        {
            id : 1,
            body : formal_body,
            hands : hands,
            wrist : wrist,
            property : "old"
        },
        {
            id : 2,
            body : formal_body1,
            hands : hands1,
            wrist : wrist1,
            property : "dark"
        },
    ],
    "suit" : [
      {
        id : 0,
        body : new_body,
        property : "fair"
      }
    ],
    "blazer" : [{
        id : 0,
        body : new_body,
        property : "fair"
    }],
    "kurta" : [
        {
            id : 0,
            body : k_body1,
            face : k_face1,
            hands_c : k_hand_c1,
            hands_n : k_hand_n1,
          property : "Model 1"
        },
        {
            id : 1,
            body : k_body2,
            face : k_face2,
            hands_c : k_hand_c2,
            hands_n : k_hand_n2,
          property : "Model 2"
        },
        {
            id : 2,
            body : k_body3,
            face : k_face3,
            hands_c : k_hand_c3,
            hands_n : k_hand_n3,
          property : "Model 3"
        },
        {
            id : 3,
            body : k_body4,
            face : k_face4,
            hands_c : k_hand_c4,
            hands_n : k_hand_n4,
          property : "Model 4"
        },
        {
            id : 4,
            body : k_body5,
            face : k_face5,
            hands_c : k_hand_c5,
            hands_n : k_hand_n5,
          property : "Model 5"
        },
        {
            id : 5,
            body : k_body6,
            face : k_face6,
            hands_c : k_hand_c6,
            hands_n : k_hand_n6,
          property : "Model 6"
        },
        {
            id : 6,
            body : k_body7,
            face : k_face7,
            hands_c : k_hand_c7,
            hands_n : k_hand_n7,
          property : "Model 7"
        }
    ],
    "pant" : [{
        id : 0,
        body : pant_body_new,
        property : "fair"
    }],
    "pajama" : [{
        id : 0,
        body : pajama_body,
        property : "Default"
    }],
    "only_kurta" : [
        {
            id : 0,
            body : k_body1,
            face : k_face1,
            hands_c : k_hand_c1,
            hands_n : k_hand_n1,
          property : "Model 1"
        },
        {
            id : 1,
            body : k_body2,
            face : k_face2,
            hands_c : k_hand_c2,
            hands_n : k_hand_n2,
          property : "Model 2"
        },
        {
            id : 2,
            body : k_body3,
            face : k_face3,
            hands_c : k_hand_c3,
            hands_n : k_hand_n3,
          property : "Model 3"
        },
        {
            id : 3,
            body : k_body4,
            face : k_face4,
            hands_c : k_hand_c4,
            hands_n : k_hand_n4,
          property : "Model 4"
        },
        {
            id : 4,
            body : k_body5,
            face : k_face5,
            hands_c : k_hand_c5,
            hands_n : k_hand_n5,
          property : "Model 5"
        },
        {
            id : 5,
            body : k_body6,
            face : k_face6,
            hands_c : k_hand_c6,
            hands_n : k_hand_n6,
          property : "Model 6"
        },
        {
            id : 6,
            body : k_body7,
            face : k_face7,
            hands_c : k_hand_c7,
            hands_n : k_hand_n7,
          property : "Model 7"
        }
    ]
  };

  Body_config.sadri = Body_config.kurta;
  Body_config.ethnic = Body_config.kurta;